import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingConnectorMetadata } from '../../api/charging-connector.ts';
import { UpdateChargingConnectorMetadataRequest } from '../../api/requests/charging-connector-request.ts';

export default function useUpdateChargingConnectorMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingConnectorMetadata>>,
  Error,
  UpdateChargingConnectorMetadataRequest
> {
  return useMutation({
    mutationFn: updateChargingConnectorMetadata,
  });
}
